import { useContext, useMemo } from 'react'
import { AuditContext } from '../../../../context/AuditContext'
import { useCurrentAudit } from './useCurrentAudit'

/**
 * The ids of the current audit's frameworks: compliance_framework_bases ids,
 * the same ids framework pickers and framework summaries carry.
 *
 * Undefined only outside an audit. In an audit the result is always a set --
 * empty while the audit loads, or if it cannot be loaded -- so an audit view
 * never falls back to every framework.
 */
export const useCurrentAuditFrameworkIds = (): {
  frameworkIds?: Set<string>
  isLoading: boolean
} => {
  const { auditId } = useContext(AuditContext)
  const { data: audit, isLoading } = useCurrentAudit()
  const frameworkIds = useMemo(
    () =>
      auditId
        ? new Set(
            audit?.getComplianceFrameworksList().map((cf) => cf.getId()) ?? [],
          )
        : undefined,
    [auditId, audit],
  )
  return { frameworkIds, isLoading }
}
